/**
 * Which of the reader's two documents is on screen.
 *
 * `product` is the gap as a customer would meet it — the product layer being
 * assembled, falling back to the run where an agent has not written yet.
 * `report` is the run's own gap, frozen and unenriched. Same draft, two zones;
 * see `product-value.ts` for why they are never mixed.
 *
 * It lives in the URL beside `execution` / `filter` / `draft` on the same
 * reasoning: a reviewer who pastes a link to something odd in the pipeline
 * output should land the other person on the pipeline output, not on the
 * product view of it.
 */
export type ReaderView = 'product' | 'report';

export const DEFAULT_READER_VIEW: ReaderView = 'product';

export function isReaderView(value: unknown): value is ReaderView {
  return value === 'product' || value === 'report';
}

export function otherReaderView(view: ReaderView): ReaderView {
  return view === 'product' ? 'report' : 'product';
}
